module.exports = __webpack_public_path__ + "img/logo1.f4134bcd.png";